import { render } from "./SpmTable.vue?vue&type=template&id=45b727e9"
import script from "./SpmTable.vue?vue&type=script&lang=ts"
export * from "./SpmTable.vue?vue&type=script&lang=ts"

import "./SpmTable.vue?vue&type=style&index=0&id=45b727e9&lang=scss"
import "./SpmTable.vue?vue&type=style&index=1&id=45b727e9&lang=scss"
script.render = render

export default script